import { useUpdateVacancyModal } from "@/features/update-vacancy"
import { IJobOpening } from "@/shared/api/employment"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchVacancies } from "../../model"
import DeleteSvg from '@/shared/assets/images/Trash.svg'
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"

interface DeleteVacancyProps {
    vacancy: IJobOpening
}

export const DeleteVacancy: FC<DeleteVacancyProps> = ({ vacancy }) => {
    const { openDeleteVacancyModal } = useUpdateVacancyModal()
    const dispatch = useAppDispatch()

    const onDelete = () => {
        dispatch(fetchVacancies())
    }

    return (
        <DropdownItem 
            onClick={() => openDeleteVacancyModal(vacancy, onDelete)}
            icon={DeleteSvg} 
            label={"Удалить"}        
        />
    )
}